import {cpsUrl} from './base'

// Place to add the list of path and links inside CPS
export const ENDPOINT = {
    base: '/',
    auth: '/auth',
    login: '/login',
    logout: '/logout',
    basePath: '/cpsreact',
    marketPlace: '/secure/search',
    viewSchedule: '/viewSchedules',
    viewFlightStatus: '/viewFlightStatus',
    //  register: '/register',
    register: '/lmsweb/new-user.jsp',
    //  inviteUser: '/inviteUser',
    inviteUser: '/lmsweb/new-user.jsp',
    homepage: '/homepage',
    contactCPS: '/contact-us',
    faqpage: '/faqpage',
    contactExistingCPS: '/lmsweb/contact-us.jsp?email=YES',
    faq: '/lmsweb/faqcps.jsp',
    publicbooking: '/lmsweb/cps_guest_booking.jsp',
    booking: '/lmsweb/secure/booking-create.jsp',
    bookingDetails: '/lmsweb/secure/booking-create-details.jsp',
    manageBranchAccess: '/lmsweb/secure/admin-carrierbranch.jsp',
    lmsweb_trackingSearch: '/lmsweb/secure/tracking-search.jsp?',
    lmsweb_allocation: '/lmsweb/secure/allocation.jsp?',
    trackShipment: '/trackShipments',
    // printLabel: '/printLabel',
    // letterOfInstructions: '/letterOfInstructions',
    resetPassword: '/resetPassword',
    ff_opsDashboard: '/secure/ff-operational-dashboard',
    acStrategicDashboard: '/secure/ac-strategic-dashboard',
    ac_opsDashboard: '/secure/ac-operational-dashboard',
    guest_dashboard: '/secure/guest-user-dashboard',
    dashboard: '/secure/dashboard',
    forgotPassword: '/forgotPassword',
    createAirwaybill: '/lmsweb/secure/retrieve-mawb.jsp',
    restricted: '/Restricted',
    branchUserRegister: '/lmsweb/new-user.jsp'
    //  branchUserRegister: '/user-register'
    // bookingservice: '/secure/booking',
    // createBooking: '/secure/booking-create',
    // shipmentDeclaration: '/shipmentDeclaration'
}

// Place to add the list of External links Outside the CPS
export const EXTERNAL_LINKS = {
    terms: `${cpsUrl}/lmsweb/cps_terms_of_use.jsp`,
    privacy: 'https://www.unisys.com/unisys-legal/privacy/',
    IATA_LINK: 'https://store.iata.org/ieccacfree'
}

export const PAGE_MAPPERS = {
    // PAGE MENU LEVEL MAPPING
    OfferMenu: '',
    RequestASpotRate: '/lmsweb/secure/spot_pricing.jsp',
    ACSpotRateOffers: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=AC&hidSpotcacc=',
    AISpotRateOffers: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=AI&hidSpotcacc=',
    MHSpotRateOffers: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=MH&hidSpotcacc=',
    NZSpotRateOffers: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=NZ&hidSpotcacc=',
    SKSpotRateOffers: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=SK&hidSpotcacc=',
    UWSpotRateOffers: '/lmsweb/secure/carrierspotoffers.jsp?selCarrier=UW&hidSpotcacc=',
    Marketplace: '/secure/search',
    Booking: '',
    SearchAvailabilityAndPrice: '/lmsweb/secure/advancedrate.jsp',
    SearchAvailableSpace: '/lmsweb/secure/availability.jsp',
    SearchAirWaybillStock: '/lmsweb/secure/awb-stock-status.jsp',
    CreateModifyBooking: '/lmsweb/secure/booking-create.jsp',
    CreateMultipleBookings: '/lmsweb/secure/booking-multiple.jsp',
    CreateModifyBookingTemplates: '/lmsweb/secure/booking-template.jsp',
    CreateRecurringBookingTemplate: 'lmsweb/secure/recurringbookingtemplate.jsp',
    CreateSpreadsheetBookings: '/lmsweb/secure/multiCarrierXlsxBooking.jsp',
    CreateAirWaybillStockRequest: '/lmsweb/secure/awb-stock-request.jsp',
    CreateAllotmentRequest: '/lmsweb/secure/requestallotments.jsp',
    ViewAllotmentStatus: '/lmsweb/secure/allocation.jsp',
    ViewRateEstimate: '/lmsweb/secure/advancedrateestimate.jsp',
    ViewCarrierSchedules: '/lmsweb/flight_schedules.jsp',
    Efreight: '',
    CreateRetrieveMAWB: '/lmsweb/secure/retrieve-mawb.jsp',
    RetrieveeDocs: '/lmsweb/secure/retrieve-edocs.jsp',
    CreateModifyHAWB: '/lmsweb/secure/customs.jsp',
    CreateModifyHAWBTemplates: '/lmsweb/secure/hawb-template.jsp?btnHawbList=Y&optUserId=BRANCH',
    CreateModifyPieceIDInfo: '/lmsweb/secure/piecedetails.jsp',
    ManageShipments: '',
    TrackShipments: '/lmsweb/tracking-awb.jsp',
    SearchAirWaybills: '/lmsweb/secure/tracking-search.jsp',
    ViewModifyBooking: '/lmsweb/secure/booking-modify.jsp',
    ReviewActiveQueuedBookings: '/lmsweb/secure/booking-summary.jsp',
    PrintBarcodeShippingLabel: '/lmsweb/secure/booking-print.jsp',
    MakeOnlinePayments: '/lmsweb/secure/booking-freight.jsp',
    ViewFlightStatus: '/lmsweb/flight_status.jsp',
    ViewCustomsStatus: '/lmsweb/customs-status.jsp',
    ViewArchivedAirWaybill: '/lmsweb/secure/archivedshipments.jsp',
    ShipmentReleaseDeclaration: '/lmsweb/secure/declaration.jsp',
    Edocs: '',
    MyBookingDocuments: '/lmsweb/secure/document_dashboard_view.jsp',
    AirWaybillDocuments: '/lmsweb/secure/document_view.jsp',
    Efinance: '',
    ViewInvoices: '/lmsweb/secure/invoiceinformation.jsp',
    ViewPaymentDetails: '/lmsweb/secure/paymentinformation.jsp',
    eClaims: '',
    CreateModifyPreliminaryClaim: '/lmsweb/secure/filepreliminaryclaim.jsp',
    CreateModifyFinalClaim: '/lmsweb/secure/filefinalclaim.jsp',
    ViewACClaimStatus: '/lmsweb/secure/claimsstatus.jsp?selCarrier=AC',
    ViewAIClaimStatus: '/lmsweb/secure/claimsstatus.jsp?selCarrier=AI',
    ViewMHClaimStatus: '/lmsweb/secure/claimsstatus.jsp?selCarrier=MH',
    ViewSKClaimStatus: '/lmsweb/secure/claimsstatus.jsp?selCarrier=SK',
    ManageAASpotRATEOffers: '/lmsweb/secure/managespotrate.jsp',
    ViewAASPOTofferqueue: '/lmsweb/secure/sraqueue.jsp?selCarrier=AA',
    FileDamageReport: '/lmsweb/secure/damagereport.jsp',
    ViewDamageReportStatus: '/lmsweb/secure/damagereportstatus.jsp',
    ManageACSpotRATEOffers: '/lmsweb/secure/managespotrate.jsp',
    ViewACSPOTofferqueue: '/lmsweb/secure/sraqueue.jsp?selCarrier=AC',
    UpdateAirWaybillStatus: '/lmsweb/secure/status_update.jsp',
    ManageAFKLSpotRATEOffers: '/lmsweb/secure/managespotrate.jsp',
    ViewAFKLSPOTofferqueue: 'lmsweb/secure/sraqueue.jsp?selCarrier=AF-KL',
    ManageAISpotRATEOffers: '/lmsweb/secure/managespotrate.jsp',
    ViewAISPOTofferqueue: '/lmsweb/secure/sraqueue.jsp?selCarrier=AI',
    ManageMHSpotRATEOffers: '/lmsweb/secure/managespotrate.jsp',
    ViewMHSPOTofferqueue: '/lmsweb/secure/sraqueue.jsp?selCarrier=MH',
    ManageNZSpotRATEOffers: '/lmsweb/secure/managespotrate.jsp',
    ViewNZSPOTofferqueue: '/lmsweb/secure/sraqueue.jsp?selCarrier=NZ',
    ManageSKSpotRATEOffers: '/lmsweb/secure/managespotrate.jsp',
    ViewSKSPOTofferqueue: '/lmsweb/secure/sraqueue.jsp?selCarrier=SK',
    ManageUASpotRATEOffers: '/lmsweb/secure/managespotrate.jsp',
    ViewUASPOTofferqueue: '/lmsweb/secure/sraqueue.jsp?selCarrier=UA',
    ManageUWSpotRATEOffers: '/lmsweb/secure/managespotrate.jsp',
    ViewUWSPOTofferqueue: '/lmsweb/secure/sraqueue.jsp?selCarrier=UW',
    // USER MANAGEMENT MAPPING
    isManageMyProfile: '/lmsweb/secure/admin-userprefs.jsp',
    isManageBranchAccess: '/lmsweb/secure/admin-carrierbranch.jsp',
    isManageCarrierProfile: '/lmsweb/secure/admin-carrierprofile.jsp',
    isManageCarrierUsers: '/lmsweb/secure/admin-carrieruser.jsp',
    isCreateCarrierUser: '/lmsweb/secure/admin-carrieruser.jsp?btnAdd=Y',
    isManageBranchProfile: '/lmsweb/secure/admin-branch.jsp',
    isManageBranchUsers: '/lmsweb/secure/admin-branchuser.jsp',
    // BRANCH USER TOOLS MAPPING
    isAAPayloadXMLSimulator: '/lmsweb/secure/aapayloadwstester.jsp',
    isXMLAuditor: '/lmsweb/secure/CPSIATAMsgs.jsp',
    // CARRIER USER TOOLS MAPPING
    isManageErrorMessages: '/lmsweb/secure/errorcodes_entry.jsp',
    isHosttoHostTranslations: '/lmsweb/secure/admin-h2htrans.jsp',
    isRestrictProducts: '/lmsweb/secure/products-restriction.jsp',
    isSpecializedBookingDatasetup: '/lmsweb/secure/ProductContactInformation.jsp',
    isURNIATAAccountMapping: '/lmsweb/secure/iata-accounts-details.jsp',
    isUploadProductSelector: '/lmsweb/secure/admin-productselector.jsp',
    isManageSpecializedBookings: '/lmsweb/secure/admin_special_booking_details.jsp?btnRetrieve=Y',
    // SERVICE USER TOOLS MAPPING
    isServiceAvailability: '/lmsweb/secure/admin-service_adv.jsp',
    isRefreshMemoryObjects: '/lmsweb/secure/RefreshMemory.jsp',
    isApprovedServices: '/lmsweb/secure/page-carriers-privilege.jsp',
    isEmailWebPages: '/lmsweb/secure/email_booking_create_details.jsp?selCarrier=AA',
    isManageMessages: '/lmsweb/secure/manage_messages.jsp',
    isManageOffers: '/lmsweb/secure/carrier_unisys_promotions.jsp'
}
